import React, { useState } from "react";
import styles from "../../../views/ReportView/ReportView.module.css";
import IconAnimation from "../../iconAnimation/iconAnimation";
import NotReportViewData from "../../NotReportViewData/NotReportView";
import { FaUserGraduate } from "react-icons/fa";

const PoliticalInformation = ({ data }) => {
  const [user, setUser] = useState(data);
  const [isEditing] = useState(false);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setUser({ ...user, [name]: value });
  };

  return (
    <div className={styles.informacionPolitica} id="politica">
      <div className={styles.sectionTitle2}>
        <h2 className={styles.sectionTitleH2}>Información Pep</h2>
        <IconAnimation />
      </div>
      {!user || !user.PoliticalInformation ? (
        <NotReportViewData title="Información PEP" Icon={FaUserGraduate} />
      ) : (
        <>
          <label className={styles.inputLabel}>
            Es políticamente expuesto:
            <select
              className={styles.inputField}
              name="politicallyExposed"
              value={user.PoliticalInformation.politicallyExposed || "No"}
              onChange={handleInputChange}
              disabled={!isEditing}
            >
              <option value="No">NO</option>
              <option value="Si">SI</option>
            </select>
          </label>
        </>
      )}
    </div>
  );
};

export default PoliticalInformation;
